import type { Anime } from "@/mocks/anime";
import AnimeCard from "@/components/feature/AnimeCard";

interface AnimeGridProps {
  items: Anime[];
  showDescription?: boolean;
  columns?: 3 | 4 | 5 | 6;
}

const columnClass: Record<number, string> = {
  3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
  5: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5",
  6: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6",
};

export default function AnimeGrid({ items, showDescription = false, columns = 5 }: AnimeGridProps) {
  return (
    <div className={`grid gap-4 md:gap-5 ${columnClass[columns]}`}>
      {items.map((anime) => (
        <AnimeCard key={anime.id} anime={anime} showDescription={showDescription} />
      ))}
    </div>
  );
}